import DrawerSimple from "ds/components/DrawerNew/Simple";
import { UserManagementActivationStatus } from "views/Account/Settings/types";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { AnalyticsPagePersonal } from "hooks/useAnalytics/pages/personal";

import { ApiKeyLegacyListView } from "../types";
import ApiKeysDetailsDrawerContent from "./Content";

type ApiKeysDetailsDrawerProps = {
  apiKey?: ApiKeyLegacyListView;
  activationStatus: UserManagementActivationStatus;
  analyticsPage: AnalyticsPageOrganization | AnalyticsPagePersonal;
};

const ApiKeysDetailsDrawer = createDrawer(
  ({ apiKey, activationStatus, analyticsPage }: ApiKeysDetailsDrawerProps) => {
    return (
      <DrawerSimple isDismissable>
        {apiKey && (
          <ApiKeysDetailsDrawerContent
            apiKey={apiKey}
            activationStatus={activationStatus}
            analyticsPage={analyticsPage}
          />
        )}
      </DrawerSimple>
    );
  }
);

export const showApiKeysDetailsDrawer = createDrawerTrigger(ApiKeysDetailsDrawer);
